import React from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import SearchSelectBox from "../../../components/SearchSelectBox";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { getStatusDeals } from "../../../api/statusDeals";
import { getServices } from "../../../api/service";
import { getLeads } from "../../../api/lead";
import { addDeal } from "../../../api/deal";

const AddDeal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    budget: Yup.number()
      .required(t("Budget is required"))
      .min(0, t("Budget must be at least 0")),
    StatusDeal: Yup.object().nullable().required(t("StatusDeal is required")),
    deliverables: Yup.array(),
    services: Yup.array(),
    leadId: Yup.object().nullable().required(t("Lead is required")),
    feedback: Yup.array(),
  });

  const { setData, loading, error, success } = useResponse(addDeal, () => {
    navigate("/deals/");
  });

  const formik = useFormik({
    initialValues: {
      budget: "",
      StatusDeal: null,
      deliverables: [],
      services: [],
      leadId: null,
      feedback: [],
      logs: []
    },
    validationSchema,
    onSubmit: (values) => {
      const timestamp = new Date().toISOString();
      const data = {
        budget: Number(values.budget),
        StatusDeal: values.StatusDeal?.value || null,
        deliverables: values.deliverables?.map((d) => d.value) || [],
        services: values.services?.map((s) => s.value) || [],
        feedbackId: values.feedback?.map((f) => f.value) || [],
        leadId: values.leadId?.value || null,
        logs:null,
      };
      setData({ data, type: "add" });
    },
  });

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={`${t("btns.Add")} ${t("Deal")}`} />

        <Form
          className="needs-validation"
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <Row>
            {/* Budget */}
            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Budget")}</Label>
                <Input
                  name="budget"
                  placeholder={t("Budget")}
                  type="number"
                  min={0}
                  onChange={formik.handleChange}
                  value={formik.values.budget}
                  invalid={!!(formik.touched.budget && formik.errors.budget)}
                />
                <FormFeedback>{formik.errors.budget}</FormFeedback>
              </FormGroup>
            </Col>
            {/* Lead */}
            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Lead")}</Label>
                <SearchSelectBox
                  api={getLeads}
                  name="leadId"
                  placeholder={t("Select Lead")}
                  value={formik.values.leadId}
                  label="name"
                  setValue={(value) => formik.setFieldValue("leadId", value)}
                  error={!!(formik.touched.leadId && formik.errors.leadId)}
                />
              </FormGroup>
            </Col>
            {/* Status Deal */}
            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Status Deal")}</Label>
                <SearchSelectBox
                  api={getStatusDeals}
                  name="StatusDeal"
                  placeholder={t("Select Status Deal")}
                  value={formik.values.StatusDeal}
                  label="name"
                  setValue={(value) => formik.setFieldValue("StatusDeal", value)}
                  error={!!(formik.touched.StatusDeal && formik.errors.StatusDeal)}
                  isMulti={false}
                />
                {formik.touched.StatusDeal && formik.errors.StatusDeal && (
                  <div className="text-danger mt-1">{formik.errors.StatusDeal}</div>
                )}
                <Link to="/status-deals/add" className="text-primary mt-2 d-block">
                  {t("Add New Status Deal")}
                </Link>
              </FormGroup>
            </Col>

            {/* Deliverables */}

            {/* Services */}
            <Col md="6">
              <FormGroup className="mb-3">
                <Label>{t("Services")}</Label>
                <SearchSelectBox
                  api={getServices}
                  name="services"
                  placeholder={t("Select Services")}
                  value={formik.values.services}
                  label="names"
                  isMulti={true}
                  setValue={(value) => formik.setFieldValue("services", value)}
                  error={!!(formik.touched.services && formik.errors.services)}
                />
                <Link to="/services/add/" className="text-primary mt-2 d-block">
                  {t("Add New Services")}
                </Link>
              </FormGroup>
            </Col>




          </Row>

          {/* Button & Result */}
          <FormButtonHandler btnTxt={t("Add")} loading={loading} />
          <ResultHandler
            error={error}
            success={success}
            successMsg={t("Created Successfully!")}
          />
        </Form>
      </Container>
    </div>
  );
};

export default AddDeal;
